// @ts-nocheck
import { useRef, useEffect, useState } from "react";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import { MapButtons } from "./MapButtons";
import { MapResizer } from "../mapUtils/MapResizer";
import { useMapData } from "../mapHooks/useMapData";
import { useBranchesLocalization } from "../mapHooks/useBranchesLocalization";
import { MapLayers } from "./MapLayers";
import { headquarter } from "../../utils/headquarter-localization";
import useStore from "../../store/useStore";
import "leaflet/dist/leaflet.css";

// Componente para atualizar o centro do mapa
function ChangeMapView({ center }: { center: [number, number] }) {
  const map = useMap();
  useEffect(() => {
    map.setView(center);
  }, [center, map]);
  return null;
}

export function Map() {
  const { showOffBtnMap, routeGPS, employeeClockIns } = useStore((state) => state);
  const mapContainerRef = useRef<HTMLDivElement>(null);
  const { branch } = useBranchesLocalization(employeeClockIns || []);
  const [mapCenter, setMapCenter] = useState<[number, number]>([
    headquarter.latitude,
    headquarter.longitude,
  ]);

  const {
    markersWithDirection,
    stopPoints,
    coloredTrajectoryLines,
    orangeTrajectoryLines,
    yellowTrajectoryLines,
  } = useMapData(routeGPS);

  useEffect(() => {
    // Priorizar centro do mapa na seguinte ordem:
    // 1. Primeira coordenada da rota (se existir)
    // 2. Localização da residência (se existir)
    // 3. Sede (padrão)
    if (yellowTrajectoryLines?.length > 0) {
      const [lat, lng] = yellowTrajectoryLines[0].positions[0];
      setMapCenter([lat, lng]);
    } else if (
      routeGPS.employeeHome &&
      routeGPS.employeeHome.latitude &&
      routeGPS.employeeHome.longitude
    ) {
      setMapCenter([routeGPS.employeeHome.latitude, routeGPS.employeeHome.longitude]);
    } else {
      setMapCenter([headquarter.latitude, headquarter.longitude]);
    }
  }, [routeGPS]);

  return (
    <div
      ref={mapContainerRef}
      className="w-full h-full flex flex-col dark:bg-gray-350 bg-gray-50 rounded-lg overflow-hidden relative"
    >
      <div className="dark:bg-gray-400 bg-gray-100 h-6 drag-handle cursor-move flex items-center px-2 rounded-t-md">
        Mapa
      </div>
      <div className="flex-grow relative">
        <MapContainer
          key="map"
          center={mapCenter}
          zoom={13}
          scrollWheelZoom={true}
          style={{
            height: "100%",
            width: "100%",
          }}
          className="m-1"
        >
          <ChangeMapView center={mapCenter} />
          <MapResizer />
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <MapLayers
            showOffBtnMap={showOffBtnMap}
            coloredTrajectoryLines={coloredTrajectoryLines}
            orangeTrajectoryLines={orangeTrajectoryLines}
            yellowTrajectoryLines={yellowTrajectoryLines}
            stopPoints={stopPoints}
            markersWithDirection={markersWithDirection}
            branch={branch}
            batidas={routeGPS.clockIns}
            employeeHome={routeGPS.employeeHome}
          />
        </MapContainer>
      </div>
      <MapButtons />
    </div>
  );
}
